import classesK from '../kalkulatori.module.css'
import classes from './paroli.module.css'
import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'

const calculatorType = 'Paroli'

const Paroli = () => {
  const [data, setData] = useState({
    values: {
      serie1: [''],
      serie2: [''],
      serie3: [''],
      stake: [''],
    },
    results: {
      serie1Results: ['', ''], // [expectedWin, profit]
      serie2Results: ['', ''],
      serie3Results: ['', ''],
    },
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: [''],
        serie2: [''],
        serie3: [''],
        stake: [''],
      },
      results: {
        serie1Results: ['', ''],
        serie2Results: ['', ''],
        serie3Results: ['', ''],
      },
    })
    setShowInputArea(true)
    setUkupno(0)
  }

  const [showInputArea, setShowInputArea] = useState(true)
  useEffect(() => {
    calculateResults()
  }, [data.values])
  const calculateResults = () => {
    setData((prevData) => {
      const updatedData = { ...prevData }
      let previousStake = parseFloat(prevData.values.stake[0]) || 0 // First stake input

      Object.keys(prevData.values).forEach((serieKey) => {
        if (serieKey.startsWith('serie')) {
          const stake = previousStake
          const odd = parseFloat(prevData.values[serieKey]?.[0]) || 1 // Ensure valid odds

          // Calculate Potential Winnings
          const potentialWinnings = stake * odd
          updatedData.results[`${serieKey}Results`] = updatedData.results[
            `${serieKey}Results`
          ] || ['-', '-']
          updatedData.results[`${serieKey}Results`][0] = isNaN(
            potentialWinnings
          )
            ? '-'
            : potentialWinnings.toFixed(2)
          console.log(potentialWinnings, stake)
          // Calculate Net Profit
          const netProfit =
            potentialWinnings - parseFloat(prevData.values.stake[0]) || 0
          updatedData.results[`${serieKey}Results`][1] = isNaN(netProfit)
            ? '-'
            : netProfit.toFixed(2)

          // Update the stake for the next series
          previousStake = netProfit > 0 ? netProfit : 0

          // Update ukupno (total) after the last   series
          console.log('previousStake', previousStake)
        }
      })
      setUkupno(
        (parseFloat(data.results.serie3Results[1]) || 0) +
          (parseFloat(data.results.serie2Results[1]) || 0) +
          (parseFloat(data.results.serie1Results[1]) || 0) -
          (parseFloat(data.values.stake[0]) || 0)
      )
      return updatedData
    })
  }

  console.log(data)

  const [series, setSeries] = useState([{ id: 1 }, { id: 2 }, { id: 3 }])

  const [ukupno, setUkupno] = useState(0)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classesK.oddsResult}>
              <div className={classesK.resultItem}>
                <span className={classesK.resultHeader}>
                  Tvoja banka nakon tri prolazne igre
                </span>
                <span>{ukupno}</span>
              </div>
            </div>
            <div className={classesK.sectionTitle}>Igra</div>
            {series.map((serie) => (
              <div key={serie.id} className={classes.seriesContainer}>
                <div className={`${classesK.calcButton} ${classes.calcButton}`}>
                  Serija br. {serie.id}
                </div>
                <div className={classes.seriesValues}>
                  <div className={classes.oddsContainer}>
                    {serie.id === 1 && (
                      <div className={classesK.oddsContainer}>
                        <span>Upiši ulog</span>
                        <input
                          type='number'
                          min='0'
                          value={data.values.stake[0]}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value)

                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                stake: [value],
                              },
                            }))
                          }}
                        />
                      </div>
                    )}
                    <div className={classesK.oddsContainer}>
                      <span>Upiši kvotu</span>
                      <input
                        type='number'
                        min='0'
                        value={data?.values[`serie${serie.id}`][0] || ''}
                        onChange={(e) => {
                          const value = parseFloat(e.target.value)

                          setData((prevData) => ({
                            ...prevData,
                            values: {
                              ...prevData.values,
                              [`serie${serie.id}`]: [value],
                            },
                          }))
                        }}
                      />
                    </div>
                  </div>
                  <ResultsSection
                    names={['Eventualni dobitak', 'Plus po seriji']}
                    results={[
                      data?.results[`serie${serie.id}Results`]
                        ? data.results[`serie${serie.id}Results`][0] || '-'
                        : '-',
                      data?.results[`serie${serie.id}Results`]
                        ? data.results[`serie${serie.id}Results`][1] || '-'
                        : '-',
                    ]}
                    allowNegative={true}
                  />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}

export default Paroli
